module.exports = __webpack_public_path__ + "img/Man-3.f34733fc.svg";